import { CellProps, Column } from "react-table";
import { formatMoney } from "../../../utils/FormatUtils";
import { TableCustomHeader } from "../../../component/table/components/TableCustomHeader";
import { TableCustomCell } from "../../../component/table/components/TableCustomCell";
import ObjectTypeCell from "../../../phan-he-kham-benh/components/modal-tab-thuoc/cells/ObjectTypeCell";

const formatCellNumber = (value: string) => {
	return value ? formatMoney(Number(value)) : '';
};

export const COLUMNS: Column<any>[] = [
	{
		Header: 'Mã Máu',
		accessor: 'code',
		width: 80,
	},
	{
		Header: 'Tên Máu',
		accessor: 'name',
		width: 400,
		Cell: ({ value }: CellProps<any>) => {
			return (
				<div className="text-truncate" title={value}>{value}</div>
			)
		},
	},
	{
		Header: 'Đơn vị',
		accessor: 'unitofMeasureName',
		width: 120,
		Cell: ({ value }: CellProps<any>) => {
			return (
				<div className="text-center">{value}</div>
			)
		},
	},
	{
		Header: 'Khả dụng',
		accessor: 'iventory',
		width: 100,
		Cell: ({ value }: CellProps<any>) => {
			return (
				<div className="text-end">{formatCellNumber(value)}</div>
			)
		},
	},
	{
		Header: "Số lô",
		accessor: "consignment",
		width: 80,
	},
	{
		Header: 'Giá BHYT',
		accessor: 'BHYTPrice',
		width: 100,
		Cell: ({ value }: CellProps<any>) => {
			return (
				<div className="text-end">{formatCellNumber(value)}</div>
			)
		},
	},
	{
		Header: 'Giá VP',
		accessor: 'hospitalFeePrice',
		width: 100,
		Cell: ({ value }: CellProps<any>) => {
			return (
				<div className="text-end">{formatCellNumber(value)}</div>
			)
		},
	},
	{
		Header: 'Giá dịch vụ',
		accessor: 'requestedPrice',
		width: 100,
		Cell: ({ value }: CellProps<any>) => {
			return (
				<div className="text-end">{formatCellNumber(value)}</div>
			)
		},
	},
	{
		Header: 'Loại Máu',
		accessor: 'materialTypeName',
		width: 200,
	},
];

export const MauSelectedColumns: ReadonlyArray<Column<any>> = [
	{
		Header: (props) => (
			<TableCustomHeader
				tableProps={props}
				title={'STT'}
				className="text-center text-light min-w-20px"
			/>
		),
		id: 'INDEX',
		Cell: ({ ...props }) => (
			<TableCustomCell className="text-center" data={(props.row.index + 1).toString()} />
		),
	},
	{
		Header: (props) => (
			<TableCustomHeader
				tableProps={props}
				title={'Tên máu'}
				className="text-center text-light min-w-250px"
			/>
		),
		id: 'Tên máu',
		Cell: ({ ...props }) => (
			<TableCustomCell className="text-start" data={props?.data[props.row.index]?.name} />
		),
	},
	{
		Header: (props) => (
			<TableCustomHeader
				tableProps={props}
				title={'Đơn vị'}
				className="text-center text-light min-w-100px"
			/>
		),
		id: 'Đơn vị',
		Cell: ({ ...props }) => (
			<TableCustomCell
				className="text-center"
				data={props?.data[props.row.index]?.unitofMeasureName}
			/>
		),
	},
	{
		Header: (props) => (
			<TableCustomHeader
				tableProps={props}
				title={'Số lượng'}
				className="text-center text-light min-w-100px"
			/>
		),
		id: 'Số lượng',
		Cell: ({ ...props }) => (
			<TableCustomCell
				className="text-center"
				data={props?.data[props.row.index]?.totalQuantity}
			/>
		),
	},
	{
		Header: (props) => (
			<TableCustomHeader
				tableProps={props}
				title={'Hướng dẫn sử dụng'}
				className="text-center text-light min-w-250px"
			/>
		),
		id: 'Hướng dẫn sử dụng',
		Cell: ({ ...props }) => (
			<TableCustomCell data={props?.data[props.row.index]?.usageInstructions} />
		),
	},
	{
		Header: (props) => (
			<TableCustomHeader
				tableProps={props}
				title='Đơn giá'
				className="text-center text-light min-w-150px"
			/>
		),
		accessor: 'donGia',
		Cell: ({ value }) => (
			<TableCustomCell
				className="text-end"
				data={formatMoney(value)}
			/>
		),
	},
	{
		Header: (props) => (
			<TableCustomHeader
				tableProps={props}
				title='Thành tiền'
				className="text-center text-light min-w-150px"
			/>
		),
		accessor: 'thanhTien',
		Cell: ({ value }) => (
			<TableCustomCell
				className="text-end"
				data={formatMoney(value)}
			/>
		),
	},
	{
		Header: (props) => (
			<TableCustomHeader
				tableProps={props}
				title="Đối tượng"
				className="p-table text-center min-w-150px"
			/>
		),
		id: 'Đối tượng',
		Cell: ObjectTypeCell,
	},
];